import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../../services/api";
import toastError from "../../../errors/toastError";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const QueueSelectSingle = ({ touched, errors, label }) => {
  const classes = useStyles();
  const [queues, setQueues] = useState([]);

  useEffect(() => {
    const loadQueues = async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) {
        toastError(`QUEUESELECTSINGLE >>> ${err}`);
      }
    };
    loadQueues();
  }, []);


  return (
    <Field name="queueId">
    {({ field, form: { setFieldValue, touched, errors } }) => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FormControl fullWidth margin="dense" variant="outlined" error={touched.queueId && Boolean(errors.queueId)}>
          <InputLabel id="queueId-label">Fila</InputLabel>
          <Select
            label="Fila"
            labelId="queueId-label"
            id="queue-selection"
            {...field}
            value={field.value || ""}
            onChange={(e) => setFieldValue("queueId", e.target.value)}
          >
            {queues.map((queue) => (
              <MenuItem key={queue.id} value={queue.id}>
                {queue.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    )}
    </Field>
  );
};

export default QueueSelectSingle;